import React, { useState } from 'react';
import { FaEllipsisV } from 'react-icons/fa';
import styles from '../styles/PortalTemplateItem.module.css';

const PortalTemplateItem = ({
  title,
  description,
  onClick,
  onDelete,
  workflowName,
  nodeName,
  deletedAt,
  templateStatus,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setMenuOpen(!menuOpen);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date
      .toLocaleDateString('en-US', { day: '2-digit', month: 'short' })
      .replace(',', '');
  };

  return (
    <div
      className={`${styles.templateItem} ${deletedAt ? styles.deleted : ''}`}
      style={{
        borderColor: templateStatus === 'publish' ? 'green' : '#ccc',
        backgroundColor: deletedAt ? '#ddd' : '',
        opacity: deletedAt ? 0.5 : 1,
      }}
      onClick={onClick}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.details}>
        <span>{workflowName}</span> | <span>{nodeName}</span>
      </div>
      <div className={styles.status}>
        <span>Status: {templateStatus || 'Draft'}</span>
        {deletedAt && (
          <span className={styles.deletedAt}>
            {' '}
            | Deleted At: {formatDate(deletedAt)}
          </span>
        )}
      </div>
      <div className={styles.menuIcon} onClick={handleMenuToggle}>
        <FaEllipsisV />
      </div>
      {menuOpen && (
        <div className={styles.menuDropdown}>
          <div onClick={onClick} className={styles.menuItem}>
            Open
          </div>
          <div onClick={handleDelete} className={styles.menuItemDelete}>
            Delete
          </div>
        </div>
      )}
    </div>
  );
};

export default PortalTemplateItem;
